import styled from 'styled-components'

export const Header = styled.p`
  font-size: 21px!important;
  font-weight: bold!important;
`

export const StyledText = styled.p`
  color: #6297FF!important;
  font-weight: 600!important;
  &:hover {
    color: #82B4FF!important;
  }
`
export const StyledSpan = styled.a`
  color: #6297FF!important;
  font-weight: 600!important;
  &:hover {
    color: #82B4FF!important;
  }
`